import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { MediaTypeEnum, ProductDto, ProductPackageDto, ResponseDto, UserDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpDownloadService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/downloads');
	}

	downloadSecureFile(uuid: string, password: string): Observable<HttpResponse<Blob>> {
		return super.postBlobWithHeaders(`/proxy/${uuid}`, {password});
	}
}
